import { render, staticRenderFns } from "./glfooter.vue?vue&type=template&id=3dc350ed&"
import script from "./glfooter.vue?vue&type=script&lang=js&"
export * from "./glfooter.vue?vue&type=script&lang=js&"
import style0 from "./glfooter.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports